module.exports = __webpack_public_path__ + "img/14.9dba35f3.jpg";